import VisibilityCombobox from 'components/comboboxes/VisibilityCombobox';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useTranslation } from 'react-i18next';
import type { TVisibility } from 'types/template/template.types';
import type { TSelectBase } from 'types/general.types';
import { AccessGroupSettings } from '../TemplateAccessSettings/AccessGroupSettings';
import { useVisibilityLabels } from 'utils/visibilityLabels';
import { useCreateTemplateState } from './CreateTemplateContext';

const CreateTemplateAccessSettings = () => {
  const { t } = useTranslation('Templates');
  const { accessGroupOptions, form } = useCreateTemplateState();
  const { newTemplate, isGlobalAllowed, onVisibilityChange, onAccessGroupChange, canShareWithOrg } = form;
  const { visibility, accessGroupIds } = newTemplate;
  const { visibilityLabel } = useVisibilityLabels();
  const visibilityItems: TSelectBase[] = [
    ...(isGlobalAllowed ? [{ label: visibilityLabel('global'), value: 'global' }] : []),
    ...(canShareWithOrg ? [{ label: visibilityLabel('client'), value: 'client' }] : []),
    ...(accessGroupOptions.length ? [{ label: visibilityLabel('local'), value: 'local' }] : []),
  ];

  return (
    <div className="flex flex-col justify-start gap-4 p-1">
      <HubertLabel className="text-sm font-medium" htmlFor="set-template-scope">
        {t('accessSettings.scopeLabel')}
      </HubertLabel>
      <VisibilityCombobox
        isMulti={false}
        onValueChange={(value) => {
          onVisibilityChange(value as TVisibility);
        }}
        value={visibility}
        disabled={false}
        items={visibilityItems}
      />
      {visibility === 'local' ? (
        <AccessGroupSettings
          accessGroupOptions={accessGroupOptions}
          isFormDisabled={false}
          visibility={visibility}
          selectedAccessGroupIds={accessGroupIds}
          onSelectedAccessGroupIdsChange={onAccessGroupChange}
          chosenAccessGroupsLackTemplateCreate={form.chosenAccessGroupsLackTemplateCreate}
        />
      ) : null}
    </div>
  );
};

export default CreateTemplateAccessSettings;
